import type { SensitivityMatrixCopy } from 'ComponentLibrary'
import type { TFunction } from 'i18next'

export const getSensitivityMatrixCopy = (tCommon: TFunction, tValuationIncomePage: TFunction): SensitivityMatrixCopy => ({
    title: tCommon('sensitivityMatrix'),
    infoTitle: tValuationIncomePage('sensitivityMatrix.infoTitle'),
    infoText: tValuationIncomePage('sensitivityMatrix.infoText'),
    legendLabel: tValuationIncomePage('sensitivityMatrix.legendLabel'),
    marketRentLabel: tCommon('marketRent'),
    discountRateLabel: tCommon('discountRate'),
    percentagePointUnit: tCommon('percentagePoints'),
    marketValue: tCommon('marketValue'),
    deltaToMarketValue: tValuationIncomePage('sensitivityMatrix.deltaToMarketValue'),
    capitalValue: tValuationIncomePage('sensitivityMatrix.capitalValue'),
    actualMultiplier: tValuationIncomePage('sensitivityMatrix.actualMultiplier'),
    actualGrossInitialYield: tValuationIncomePage('sensitivityMatrix.actualGrossInitialYield'),
})
